/* istanbul ignore file */

import { User } from '@angular/fire/auth';
import { Firestore } from '@angular/fire/firestore';

import {
  getChannelPublicSettings,
  getExternalPlanProviders,
} from '@yoimo/client-sdk/channels';
import { getUserInfo$, UserInfoWithDocId } from '@yoimo/client-sdk/users';
import { Sport80ExternalInfo, Sport80PlanProvider } from '@yoimo/interfaces';

import { first, map, Observable, switchMap, take, withLatestFrom } from 'rxjs';

import { AuthService } from '@core/services';

export function getSport80Settings$(
  fs: Firestore,
  channelId: string,
  userId: string,
  mustBeEnabled?: boolean
): Observable<Sport80PlanProvider | undefined> {
  return getChannelPublicSettings(fs, channelId).pipe(
    map((s) => getExternalPlanProviders(s, userId)),
    map((externalProviders) => {
      const sport80 = externalProviders.find(
        (p) => p.id === 'sport80' && p.enabled
      );
      if (!sport80 && mustBeEnabled) throw new Error('Sport80MustBeDefined');
      return sport80;
    })
  );
}

export function getUserSport80Account(
  channelId: string,
  userInfo: UserInfoWithDocId
): Sport80ExternalInfo | undefined {
  if (!userInfo?.externalIntegrationsData?.payment) return undefined;
  if (!userInfo.externalIntegrationsData.payment['sport80']) return undefined;

  return userInfo.externalIntegrationsData.payment.sport80[channelId];
}

export function getSport80Account$(
  fs: Firestore,
  authService: AuthService,
  channelId: string
) {
  return authService.user$.pipe(
    first((user): user is User => user !== null),
    switchMap((user) => getUserInfo$(user.uid, fs)),
    map((userInfo) => {
      if (!userInfo) throw new Error('MustBeLoggedIn');
      return getUserSport80Account(channelId, userInfo);
    }),
    take(1)
  );
}
